// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"11fe5534","453":"a552295b","667":"bdbd680f","946":"08a9461f"}[chunkId] + ".chunk.js";
};